<script setup lang="ts">
import type { ModelRef } from "vue";

const showPkiForm: ModelRef<boolean> = defineModel<boolean>("showPkiForm", {
  required: true,
});
const currentSelectedPki: ModelRef<string | undefined> = defineModel<
  string | undefined
>("currentSelectedPki");
</script>

<template>
  <pki-list
    v-model:show-pki-form="showPkiForm"
    v-model:current-selected-pki="currentSelectedPki"
  />
</template>
